import React, {PropTypes} from "react";
import {connect} from "react-redux";
import ItExitTable from "./ItExitTable";
import axios from "axios";
import Modal from "./ModalIt";
import ModalDelete from "../../hradmin/Exit/ModalDelete";
import LoadingSpinner from "../../loadingSpinner";

function convert(node) {
  node.doLeaving = node.doLeaving ? new Date(node.doLeaving) : null;
  node.doResignation = node.doResignation ? new Date(node.doResignation) : null;
  return node;
}
class ItExitHome extends React.Component {

  constructor() {
    super();
    this.state = {employees: [], employee: null, open: false, openDelete: false, disabled: false, loading:true}
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this.edit = this.edit.bind(this);
    this.refresh = this.refresh.bind(this);
    this.openExit = this.openExit.bind(this);
    this.closeExit = this.closeExit.bind(this);
    this.trueDisable = this.trueDisable.bind(this);
    this.falseDisable = this.falseDisable.bind(this);
  }

  trueDisable() {
    this.setState({disable: true})
  }

  falseDisable() {
    this.setState({disable: false})
  }

  openExit() {
    this.setState({openDelete: true})
  }

  closeExit() {
    this.setState({openDelete: false})
  }

  open() {
    this.setState({open: true})
  }

  close() {
    this.setState({open: false})
  }

  edit(employee) {
    this.setState({employee: employee});
  }

  refresh() {
    axios.get(process.env.REQ_URL + "/getExits", {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
      let employees = response.data.data;
      let newEmployees = new Array();
      
      employees.map((node)=> {
        if (node.empStatus != "P")
          if (node.doLeaving != null && node.itStatus != null) {
            let todayDate = new Date();
            let dol = new Date(node.doLeaving);
            if (new Date(node.doLeaving) <= todayDate && node.itStatus == 'pending' || node.itStatus.substr(0, 9) == 'completed')
              newEmployees.push(node);
            else if (dol.getDate() == todayDate.getDate() && dol.getDay() == todayDate.getDay() && node.itStatus == 'completed')
              newEmployees.push(node);
          }
      });
      this.setState({employees: newEmployees, loading: false})
    }).catch((err)=> {
    });
  }

  componentDidMount() {
    axios.get(process.env.REQ_URL + "/getExits", {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
      let employees = response.data.data;
      let newEmployees = new Array();

      employees.map((node)=> {
        if (node.empStatus != "P") {
          if (node.doLeaving != null && node.itStatus!=null) {
            let todayDate = new Date();
            let dol = new Date(node.doLeaving);
            if (new Date(node.doLeaving) <= todayDate && (node.itStatus == 'pending' || node.itStatus.substr(0, 9) == 'completed'))
              newEmployees.push(node);
            else if (dol.getDate() == todayDate.getDate() && dol.getDay() == todayDate.getDay() && node.itStatus == 'completed')
              newEmployees.push(node);
          }
        }

      });
      this.setState({employees: newEmployees, loading:false})
    }).catch((err)=> {
    });
  }

  render() {
    return (
      <div>
        {this.state.employee == null ? null : <Modal user={this.props.user}
                                                     employee={this.state.employee}
                                                     open={this.state.open}
                                                     edit={this.edit}
                                                     close={this.close}
                                                     refresh={this.refresh}/>}
        {this.state.employee == null ? null : <ModalDelete employee={this.state.employee}
                                                           empRefresh={this.props.refresh}
                                                           remove={this.props.remove}
                                                           disabled={this.state.disable}
                                                           open={this.state.openDelete}
                                                           edit={this.edit}
                                                           close={this.closeExit}
                                                           refresh={this.refresh}/>}
          { this.state.loading ? <LoadingSpinner/> :<ItExitTable
          trueDisable={this.trueDisable}
          falseDisable={this.falseDisable}
          edit={this.edit}
          open={this.open}
          openExit={this.openExit}
          constants={this.props.constants}
          employees={this.state.employees}/> }
      </div>
    );
  }

}

ItExitHome.propTypes = {};

function mapStateToProps(state, ownState) {
  return {
    user: state.emp[0]
  };

}

export default connect(mapStateToProps)(ItExitHome);




/** WEBPACK FOOTER **
 ** ./src/feature/it/Exit/ItExitHome.js
 **/